/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_privacy_section_9_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`9. Children’s Privacy`)
};

const es_privacy_section_9_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`9. Privacidad de Menores`)
};

const de_privacy_section_9_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`9. Datenschutz für Kinder`)
};

const nl_privacy_section_9_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`9. Privacy van kinderen`)
};

const fr_privacy_section_9_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`9. Confidentialité des enfants`)
};

const it_privacy_section_9_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`9. Privacy dei minori`)
};

const pt_br2_privacy_section_9_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`9. Privacidade de crianças`)
};

const pt_privacy_section_9_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`9. Privacidade de crianças`)
};

const ja_privacy_section_9_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`9. 子供のプライバシー`)
};

const zh_privacy_section_9_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`9. 儿童隐私`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const privacy_section_9_title = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.privacy_section_9_title(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("privacy_section_9_title", locale)
	if (locale === "en") return en_privacy_section_9_title(inputs)
	if (locale === "es") return es_privacy_section_9_title(inputs)
	if (locale === "de") return de_privacy_section_9_title(inputs)
	if (locale === "nl") return nl_privacy_section_9_title(inputs)
	if (locale === "fr") return fr_privacy_section_9_title(inputs)
	if (locale === "it") return it_privacy_section_9_title(inputs)
	if (locale === "pt-BR") return pt_br2_privacy_section_9_title(inputs)
	if (locale === "pt") return pt_privacy_section_9_title(inputs)
	if (locale === "ja") return ja_privacy_section_9_title(inputs)
	return zh_privacy_section_9_title(inputs)
};